var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSegment = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 3a1 1 0 0 0-1 1v3h6v6h3a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 8H2v5a1 1 0 0 0 1 1h5V8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSegment);
export default ForwardRef;